import React, { useEffect, useState, useMemo, useRef } from "react";
import axios from "axios";
import usePermission from "../../../config/permissions";
import { BASE_URL } from "./../../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import { Office, SearchBig, SearchSmall } from "../../AllSvg";
import {
  AddEmployeeLetter,
  AddLetterFormat,
  AddLetterTemplate,
  LetterUpdate,
  LetterDelete,
  LetterFormatUpdate,
  LetterFormatDelete,
  // EmpLetterUpdate,
  EmpLetterDelete,
  ViewEmpMailFormat,
  ViewLetterBuilder,
} from "./LetterTemplateComponentsTesting";
import {
  handleErrorToast,
  pageSizeOptions,
  SearchFilterInput,
} from "../../CustomFunctions";
import { formatDate, formatDateTime } from "../../Date";
import {
  DownloadBulkDocumentsAsZip,
  ViewFile,
  CustomTooltip,
} from "../../CustomFunctions";
import Select from "react-select";
import { CSSForDropdownFilter2 } from "../../CustomUtilities";

// ---------------------------------------------------letter Template start -------------------------


const LetterTemplatesTable = () => {
  const [toggleCompany, setToggleCompany] = useState(
    sessionStorage.getItem("company_id"),
  );
  const [buffer, setBuffering] = useState(true);
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

  const [lettersTemplate, setLettersTemplateData] = useState([]);
  const [filteredTemplates, setFilteredTemplates] = useState([]);

  // filters
  const [templateName, setTemplateName] = useState("");
  const [pageSize, setPageSize] = useState("");

  const getLetterTemplates = async () => {
    setBuffering(true);

    try {
      const template = await axios.get(
        `${BASE_URL}/wfm/letter-builder-template-bysubcompany/${toggleCompany}/`,
      );

      setLettersTemplateData(template.data);
      setFilteredTemplates(template.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getLetterTemplates();
  }, [toggleCompany]);

  const handlePageSizeChange = (selectedOption) => {
    if (selectedOption) {
      setPageSize(selectedOption.value);
    } else {
      setPageSize("");
    }
  };

  // ================= FILTER LOGIC =================
  useEffect(() => {
    let filteredData = [...lettersTemplate];

    // Template Name Filter
    if (templateName) {
      filteredData = filteredData.filter((i) =>
        (i?.template_name || "")
          .toLowerCase()
          .includes(templateName.toLowerCase()),
      );
    }

    // Page Size Filter
    if (pageSize) {
      filteredData = filteredData.filter((i) =>
        (i?.page_size || "").toLowerCase().includes(pageSize.toLowerCase()),
      );
    }

    setFilteredTemplates(filteredData);
  }, [lettersTemplate, templateName, pageSize]);

  return (
    <>
      {/* ================= HEADING & FILTER ================= */}
      <div style={{ margin: "10px" }} className="content-tabs">
        <div className="field-parent-cont" style={{ gap: "20px" }}>
          <div className="field-cont">
            {SUPER_ADMIN ? (
              <div className="field-cont-div">
                <select
                  onChange={(e) => setToggleCompany(e.target.value)}
                  value={toggleCompany}
                  className="attendance-input-field width-12vw date-field"
                >
                  <option value="null">Select Sub Company</option>

                  {SUB_COMPANIES.map((company) => (
                    <option key={company.id} value={company.id}>
                      {company.title}
                    </option>
                  ))}
                </select>

                <hr className="field-cont-hr" />
              </div>
            ) : null}

            {/* Template Name Filter */}
            {/* <div className="field-cont-div-svg">
                            <SearchBig />

                            <input
                                placeholder="By Template Name"
                                className="attendance-input-field width-16vw"
                                value={templateName}
                                onChange={(e) => setTemplateName(e.target.value)}
                            />

                            <hr className="field-cont-hr" />
                        </div> */}
            <SearchFilterInput
              placeholder="By Template Name"
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              onClear={() => setTemplateName("")}
              widthClass="width-16vw"
            />

            {/* Page Size Filter */}
            {/* <div className="field-cont-div-svg">
                            <SearchBig />

                            <input
                                placeholder="By Page Size"
                                className="attendance-input-field width-12vw"
                                value={pageSize}
                                onChange={(e) => setPageSize(e.target.value)}
                            />

                            <hr className="field-cont-hr" />
                        </div> */}
            {/* ================= PAGE SIZE FILTER ================= */}

            <div className="field-cont-div">
              <>
                <Select
                  className="attendance-input-field width-18vw"
                  options={pageSizeOptions}
                  value={
                    pageSizeOptions.find(
                      (option) => option.value === pageSize,
                    ) || pageSizeOptions[0]
                  }
                  placeholder="Select Page Size"
                  onChange={handlePageSizeChange}
                  isClearable
                  styles={CSSForDropdownFilter2}
                />
              </>

              <hr className="field-cont-hr" />
            </div>
          </div>
          <div className="letter-template-btn">
            <AddLetterTemplate
              SUPER_ADMIN={SUPER_ADMIN}
              SUB_COMPANIES={SUB_COMPANIES}
              getLetterTemplateData={getLetterTemplates}
            />
          </div>
        </div>

        {/* ================= TABLE ================= */}
        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500 font-size-heading">
              Letter Template
            </div>
          </div>
          <table className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">S. No.</th>
                <th className="align-center">Template Name</th>
                <th className="align-center">Company</th>
                <th className="align-center">Preview Template</th>
                <th className="align-center">Content</th>
                <th className="align-center">Page Size</th>
                <th className="align-center">Total Letter Usage Count</th>
                <th className="align-center">Created At</th>
                <th className="align-center">Action</th>
              </tr>
            </thead>

            {buffer ? (
              <div className="spinner"></div>
            ) : (
              <tbody>
                {filteredTemplates
                  ?.sort(
                    (a, b) => new Date(b.created_at) - new Date(a.created_at),
                  )
                  ?.map((i, index) => (
                    <React.Fragment key={index}>
                      <tr className="tr-border-bottom">
                        <td colSpan="6"></td>
                      </tr>

                      <tr className="custom-table-head-td">
                        <td className="align-left">{index + 1}</td>

                        <td className="align-center">{i?.template_name}</td>

                        <td className="align-center">
                          {i?.sub_company_title}{" "}
                          {i?.company_defaults_count > 0 ? (
                            <button className="priority-button color-tab-red">
                              Default
                            </button>
                          ) : null}
                        </td>

                        <td key={i.id} className="align-center">
                          <ViewLetterBuilder
                            buttonDisplay={"Eye-Name"}
                            templateData={i}
                          />
                        </td>

                        <td className="align-center">
                          <>
                            {!(
                              i?.bg_image ||
                              i?.header_logo ||
                              i?.footer_logo ||
                              i?.header_full_image ||
                              i?.footer_full_image
                            ) ? (
                              <span>-</span>
                            ) : (
                              <ul>
                                {i?.bg_image && <li>Background Image</li>}

                                {i?.header_logo && <li>Header Logo</li>}

                                {i?.footer_logo && <li>Footer Logo</li>}

                                {i?.header_full_image && <li>Header Image</li>}

                                {i?.footer_full_image && <li>Footer Image</li>}

                                {i?.signatory_signature && (
                                  <li>Signature Image</li>
                                )}
                              </ul>
                            )}
                          </>
                        </td>

                        <td className="align-center">{i?.page_size}</td>

                        <td className="align-center">
                          <CustomTooltip
                            position="top"
                            tooltipContent={
                              <div>
                                <div>
                                  Letter Formats:
                                  <strong> {i?.letter_format_count}</strong>
                                </div>

                                <div>
                                  Employee Letters:
                                  <strong> {i?.employee_letter_count}</strong>
                                </div>

                                <div>
                                  Increment Letters:
                                  <strong> {i?.increment_letter_count}</strong>
                                </div>

                                <div>
                                  Employee Defaults:
                                  <strong> {i?.employee_defaults_count}</strong>
                                </div>
                              </div>
                            }
                          >
                            <span
                              style={{
                                cursor: "pointer",
                                textDecoration: "underline",
                                color: "#007bff",
                              }}
                            >
                              {i?.total_letter_usage_count +
                                i?.employee_defaults_count}
                            </span>
                          </CustomTooltip>
                        </td>

                        <td className="align-center">
                          {formatDate(i?.created_at)}
                        </td>

                        <td className="align-center">
                          <div className="flex-row">
                            <LetterUpdate
                              i={i}
                              SUPER_ADMIN={SUPER_ADMIN}
                              SUB_COMPANIES={SUB_COMPANIES}
                              getLetterTemplateData={getLetterTemplates}
                            />

                            {i.total_letter_usage_count === 0 && (
                              <LetterDelete
                                i={i}
                                getLetterTemplateData={getLetterTemplates}
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            )}
          </table>
        </div>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

// ---------------------------------------------------letter Template end -------------------------

// ---------------------------------------------------letter format start -------------------------


const LetterFormatsTable = () => {
  const [toggleCompany, setToggleCompany] = useState(
    sessionStorage.getItem("company_id"),
  );

  const [buffer, setBuffering] = useState(true);

  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

  const [letterFormats, setLetterFormatsData] = useState([]);
  const [filteredFormats, setFilteredFormats] = useState([]);

  // ================= FILTER STATES =================
  const [letterName, setLetterName] = useState("");
  const [letterType, setLetterType] = useState("");
  const [letterSubject, setLetterSubject] = useState("");

  const getLetterFormats = async () => {
    setBuffering(true);

    try {
      const template = await axios.get(
        `${BASE_URL}/wfm/letter-builder-formatwithvariables-bysubcompany/${toggleCompany}/`,
      );

      setLetterFormatsData(template.data);
      setFilteredFormats(template.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getLetterFormats();
  }, [toggleCompany]);

  // ================= FILTER LOGIC =================
  // ================= FILTER LOGIC =================
  useEffect(() => {
    let filteredData = [...letterFormats];

    // Letter Name Filter
    if (letterName) {
      filteredData = filteredData.filter((i) =>
        (i?.letter_name || "").toLowerCase().includes(letterName.toLowerCase()),
      );
    }

    // Letter Type Filter
    if (letterType) {
      filteredData = filteredData.filter((i) =>
        (i?.letter_type || "").toLowerCase().includes(letterType.toLowerCase()),
      );
    }

    // Letter Subject Filter
    if (letterSubject) {
      filteredData = filteredData.filter((i) =>
        (i?.subject || "").toLowerCase().includes(letterSubject.toLowerCase()),
      );
    }

    setFilteredFormats(filteredData);
  }, [letterFormats, letterName, letterType, letterSubject]);

  return (
    <>
      {/* ================= FILTER SECTION ================= */}

      <div style={{ margin: "10px" }} className="content-tabs">
        <div className="field-parent-cont" style={{ gap: "20px" }}>
          <div className="field-cont">
            {/* SUB COMPANY */}
            {SUPER_ADMIN ? (
              <div className="field-cont-div">
                <select
                  onChange={(e) => setToggleCompany(e.target.value)}
                  value={toggleCompany}
                  className="attendance-input-field width-12vw date-field"
                >
                  <option value="null">Select Sub Company</option>

                  {SUB_COMPANIES.map((company) => (
                    <option key={company.id} value={company.id}>
                      {company.title}
                    </option>
                  ))}
                </select>

                <hr className="field-cont-hr" />
              </div>
            ) : null}

            {/* ================= LETTER NAME FILTER ================= */}

            <SearchFilterInput
              placeholder="By Letter Name"
              value={letterName}
              onChange={(e) => setLetterName(e.target.value)}
              onClear={() => setLetterName("")}
              widthClass="width-16vw"
            />

            {/* LETTER TYPE */}
            <SearchFilterInput
              placeholder="By Letter Type"
              value={letterType}
              onChange={(e) => setLetterType(e.target.value)}
              onClear={() => setLetterType("")}
              widthClass="width-14vw"
            />

            {/* SUBJECT */}
            <SearchFilterInput
              placeholder="By Subject"
              value={letterSubject}
              onChange={(e) => setLetterSubject(e.target.value)}
              onClear={() => setLetterSubject("")}
              widthClass="width-16vw"
            />
          </div>

          {/* RIGHT SIDE BUTTON */}
          <div className="letter-template-btn">
            <AddLetterFormat
              getLetterFormatsData={getLetterFormats}
              SUPER_ADMIN={SUPER_ADMIN}
              SUB_COMPANIES={SUB_COMPANIES}
            />
          </div>
        </div>

        {/* ================= TABLE ================= */}

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500 font-size-heading">
              Letter Formats
            </div>
          </div>

          <table className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">S. No.</th>

                <th className="align-center">Letter Name</th>

                <th className="align-center">Sub Company</th>

                <th className="align-center">Letter Type (Rating)</th>

                <th className="align-center">Subject</th>

                <th className="align-center">Content View</th>

                <th className="align-center">Created At</th>

                <th className="align-center">Employee Letter Count</th>

                <th className="align-center">Action</th>
              </tr>
            </thead>

            {buffer ? (
              <div className="spinner"></div>
            ) : (
              <tbody>
                {filteredFormats
                  ?.sort((a, b) => a.letter_name?.localeCompare(b.letter_name))

                  ?.map((i, index) => (
                    <React.Fragment key={index}>
                      <tr className="custom-table-head-td">
                        <td className="align-left">{index + 1}</td>

                        <td className="align-center">{i.letter_name || "-"}</td>

                        <td className="align-center">
                          {i.sub_company_title || "-"}
                        </td>
                        {/* 
                                                <td className="align-center">

                                                    {i.letter_type}

                                                    <span
                                                        className={`${i.letter_type === 'positive'
                                                            ? 'text-success-color'
                                                            : i.letter_type === 'negative'
                                                                ? 'text-danger-color'
                                                                : ''
                                                            }`}
                                                    >
                                                        ({i.letter_rating})
                                                    </span>

                                                </td> */}
                        <td className="align-center">
                          {i.letter_type}
                          <span
                            className={`${i.letter_type === "positive"
                              ? "text-success-color"
                              : i.letter_type === "negative"
                                ? "text-danger-color"
                                : ""
                              }`}
                          >
                            ({parseFloat(i.letter_rating)})
                          </span>
                        </td>

                        <td className="align-center">{i.subject || "-"}</td>

                        <td key={i.id} className="align-center">
                          <ViewLetterBuilder
                            buttonDisplay={"Eye-Name"}
                            templateID={i.letter_template}
                            formatData={i}
                          />
                        </td>

                        <td className="align-center">
                          {formatDate(i?.created_at)}
                        </td>

                        <td className="align-center">
                          {i?.employee_letter_count}
                        </td>

                        <td className="align-center">
                          <div className="flex-row">
                            <LetterFormatUpdate
                              i={i}
                              SUPER_ADMIN={SUPER_ADMIN}
                              SUB_COMPANIES={SUB_COMPANIES}
                              getLetterFormatsData={getLetterFormats}
                            />

                            {i?.employee_letter_count == 0 && (
                              <LetterFormatDelete
                                i={i}
                                getLetterFormatsData={getLetterFormats}
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            )}
          </table>
        </div>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

// ---------------------------------------------------letter format end-------------------------

const LetterToEmployeeTable = () => {
  const [toggleCompany, setToggleCompany] = useState(
    sessionStorage.getItem("company_id"),
  );

  const [buffer, setBuffering] = useState(true);

  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

  const [employeeletters, setEmployeeLettersData] = useState([]);
  const [filteredEmployeeLetters, setFilteredEmployeeLetters] = useState([]);

  // ================= FILTER STATES =================
  const [employeeSearch, setEmployeeSearch] = useState("");
  const [letterContentName, setLetterContentName] = useState("");
  const [letterType, setLetterType] = useState("");
  const [ccRecipients, setCcRecipients] = useState("");

  const getEmployeeLetters = async () => {
    setBuffering(true);

    try {
      const template = await axios.get(
        `${BASE_URL}/wfm/letter-builder-employeeletterwithvariables-bysubcompany/${toggleCompany}/`,
      );

      setEmployeeLettersData(template.data);
      setFilteredEmployeeLetters(template.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getEmployeeLetters();
  }, [toggleCompany]);

  // ================= FILTER LOGIC =================
  useEffect(() => {
    let filteredData = [...employeeletters];

    // ================= EMPLOYEE NAME / CODE FILTER =================
    if (employeeSearch) {
      filteredData = filteredData.filter((i) => {
        return i.multiple_employees?.some((emp) => {
          const empCode = (emp?.emp_code || "").toLowerCase();

          const empName = (emp?.name || "").toLowerCase();

          return (
            empCode.includes(employeeSearch.toLowerCase()) ||
            empName.includes(employeeSearch.toLowerCase())
          );
        });
      });
    }

    // ================= LETTER CONTENT NAME FILTER =================
    if (letterContentName) {
      filteredData = filteredData.filter((i) =>
        (i?.letter_content_name || "")
          .toLowerCase()
          .includes(letterContentName.toLowerCase()),
      );
    }

    // ================= LETTER TYPE FILTER =================
    if (letterType) {
      filteredData = filteredData.filter((i) =>
        (i?.letter_content_type || "")
          .toLowerCase()
          .includes(letterType.toLowerCase()),
      );
    }

    // ================= CC RECIPIENTS FILTER =================
    if (ccRecipients) {
      filteredData = filteredData.filter((i) => {
        const ccList = i?.email_cc?.join(", ")?.toLowerCase() || "";

        return ccList.includes(ccRecipients.toLowerCase());
      });
    }

    setFilteredEmployeeLetters(filteredData);
  }, [
    employeeletters,
    employeeSearch,
    letterContentName,
    letterType,
    ccRecipients,
  ]);

  return (
    <>
      {/* ================= FILTER SECTION ================= */}

      <div style={{ margin: "10px" }} className="content-tabs">
        <div className="field-parent-cont" style={{ gap: "20px" }}>
          <div className="field-cont">
            {/* SUB COMPANY */}
            {SUPER_ADMIN ? (
              <div className="field-cont-div">
                <select
                  onChange={(e) => setToggleCompany(e.target.value)}
                  value={toggleCompany}
                  className="attendance-input-field width-12vw date-field"
                >
                  <option value="null">Select Sub Company</option>

                  {SUB_COMPANIES.map((company) => (
                    <option key={company.id} value={company.id}>
                      {company.title}
                    </option>
                  ))}
                </select>

                <hr className="field-cont-hr" />
              </div>
            ) : null}

            {/* EMPLOYEE NAME/CODE */}
            <SearchFilterInput
              placeholder="By Emp Name / Code"
              value={employeeSearch}
              onChange={(e) => setEmployeeSearch(e.target.value)}
              onClear={() => setEmployeeSearch("")}
              widthClass="width-18vw"
            />

            {/* LETTER CONTENT NAME */}
            <SearchFilterInput
              placeholder="By Letter Content Name"
              value={letterContentName}
              onChange={(e) => setLetterContentName(e.target.value)}
              onClear={() => setLetterContentName("")}
              widthClass="width-18vw"
            />

            {/* LETTER TYPE */}
            <SearchFilterInput
              placeholder="By Letter Type"
              value={letterType}
              onChange={(e) => setLetterType(e.target.value)}
              onClear={() => setLetterType("")}
              widthClass="width-14vw"
            />

            {/* CC RECIPIENT */}
            <SearchFilterInput
              placeholder="By CC Recipients"
              value={ccRecipients}
              onChange={(e) => setCcRecipients(e.target.value)}
              onClear={() => setCcRecipients("")}
              widthClass="width-18vw"
            />
          </div>

          {/* RIGHT BUTTON */}
          <div className="letter-template-btn">
            <AddEmployeeLetter
              getEmployeeLettersData={getEmployeeLetters}
              SUPER_ADMIN={SUPER_ADMIN}
              SUB_COMPANIES={SUB_COMPANIES}
            />
          </div>
        </div>

        {/* ================= TABLE ================= */}

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500 font-size-heading">
              Employee Letters
            </div>
          </div>

          <table className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">S. No.</th>

                <th className="align-center">Employee</th>

                <th className="align-center">Letter Content Name</th>

                <th className="align-center">Sub Company</th>

                <th className="align-center">Letter Type (Rating)</th>

                <th className="align-center">View Mail</th>

                <th className="align-center">CC Recipients</th>

                <th className="align-center">View Attachments</th>

                <th className="align-center">Sent At</th>

                <th className="align-center">Action</th>
              </tr>
            </thead>

            {buffer ? (
              <div className="spinner"></div>
            ) : (
              <tbody>
                {filteredEmployeeLetters
                  ?.sort(
                    (a, b) => new Date(b.created_at) - new Date(a.created_at),
                  )

                  .map((i, index) => (
                    <React.Fragment key={index}>
                      <tr className="custom-table-head-td">
                        <td className="align-left">{index + 1}</td>

                        {/* EMPLOYEE */}
                        <td className="align-center employee-column">
                          {i.multiple_employees?.length > 0 ? (
                            i.multiple_employees.map((emp, idx) => (
                              <div key={idx} className="employee-item">
                                {emp.emp_code} - {emp.name}
                              </div>
                            ))
                          ) : (
                            <span>No Employees</span>
                          )}
                        </td>

                        <td className="align-center">
                          {i.letter_content_name}
                        </td>

                        <td className="align-center">{i.sub_company_title}</td>

                        {/* LETTER TYPE */}
                        <td className="align-center">
                          {i.letter_content_type}

                          <span
                            className={`${i.letter_content_type === "positive"
                              ? "text-success-color"
                              : i.letter_content_type === "negative"
                                ? "text-danger-color"
                                : ""
                              }`}
                          >
                            ({i.letter_content_rating})
                          </span>
                        </td>

                        {/* VIEW MAIL */}
                        <td key={i.id} className="align-center">
                          {i?.email_sent ? (
                            <ViewEmpMailFormat letterFormat={i} />
                          ) : (
                            "No email sent"
                          )}
                        </td>

                        {/* CC */}
                        <td className="align-center">
                          {i.email_cc?.length > 0 ? (
                            <table>
                              <tbody>
                                <tr className="no-border-table">
                                  <td style={{ maxWidth: "fit-content" }}>
                                    {i.email_cc.join(", ")}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          ) : (
                            <span>No CC Recipients</span>
                          )}
                        </td>

                        {/* ATTACHMENT */}
                        <td>
                          {i?.email_documents?.length > 0 ? (
                            <table>
                              <tbody>
                                {i?.email_documents?.map((doc, docIndex) => (
                                  <tr
                                    key={docIndex}
                                    className="no-border-table"
                                  >
                                    <td>{doc.name}:</td>

                                    {doc?.url &&
                                      Object.keys(doc?.url).length > 0 ? (
                                      <td>
                                        <ViewFile
                                          doc={doc}
                                          filename={doc.name}
                                          filesrc={doc.url}
                                          defaultIcon={true}
                                        />{" "}
                                        View
                                      </td>
                                    ) : (
                                      "-"
                                    )}
                                  </tr>
                                ))}

                                <tr>
                                  <th>Get Zip:</th>

                                  <th>
                                    <DownloadBulkDocumentsAsZip
                                      document_list={i?.email_documents}
                                      doc_name_key={"name"}
                                      doc_file_key={"url"}
                                      downloadBlueButton={true}
                                    />
                                  </th>
                                </tr>
                              </tbody>
                            </table>
                          ) : (
                            <span>No documents available</span>
                          )}
                        </td>

                        <td className="align-center">
                          {formatDateTime(i?.created_at).longfull}
                        </td>

                        {/* ACTION */}
                        <td className="align-center flex-row">
                          {SUPER_ADMIN && i?.email_sent ? (
                            ""
                          ) : (
                            <EmpLetterDelete
                              i={i}
                              getEmployeeLettersData={getEmployeeLetters}
                            />
                          )}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            )}
          </table>
        </div>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export { LetterTemplatesTable, LetterFormatsTable, LetterToEmployeeTable };
